import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { NvIconModule } from '../../design/nv-icon/nv-icon.module';
import { NvBoxButtonComponent } from './nv-box-button.component';
import { NvBoxModule } from '../nv-box/nv-box.module';
import { NvAriaLabelModule } from '../directives/nv-aria-label/nv-aria-label.module';

@NgModule({
  declarations: [NvBoxButtonComponent],
  exports: [NvBoxButtonComponent],
  imports: [CommonModule, MatRippleModule, NvIconModule, NvBoxModule, NvAriaLabelModule],
})
export class NvBoxButtonModule {}
